import { get } from 'lodash';
import { compose, withPropsOnChange, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { withClassname } from '@components/hoc/withClassname';
import * as React from 'react';
import { dictionaryTemplates } from '@modules/dictionary/_dictionaryTemplates';
import defaultColumns from '@modules/dictionary/_dictionaryColumns';
import { DictionaryForm } from '@modules/dictionary/DictionaryForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { getConfigurationContext } from '@components/provider/configuration/ConfigurationProvider';
import useColumnSettings from '@modules/columnSettings/_columnSettingsStore';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const DictionaryGrid = compose(
  withRouter,
  setDisplayName('DictionaryGrid'),
  withPropsOnChange(['match'], ({ match: { params: { dictionary } } }) => ({
    group: get(dictionaryTemplates, dictionary, {}),
    dictionary
  })),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs(({ group }) => [{ label: get(group, 'title', '') }]),
  withProps(({ group, dictionary }) => {
    const context = getConfigurationContext();

    const dictionaryGridName = `DictionaryGrid-${dictionary}`;
    const { addColumnsToDictionaryAgenda, columns } = useColumnSettings();

    React.useEffect(
      () => {
        let newColumns = columns[dictionaryGridName] ? columns[dictionaryGridName] : [];
        if (!columns[dictionaryGridName]) {
          newColumns = addColumnsToDictionaryAgenda(
            dictionaryGridName,
            (get(group, 'columns') || defaultColumns).map(v => ({ ...v, active: true }))
          );
        }
        const cachedString = localStorage.getItem(dictionaryGridName);
        if (cachedString !== null) {
          const cached = JSON.parse(cachedString);
          cached.columns = newColumns;
          // localStorage.removeItem(dictionaryGridName);
          localStorage.setItem(dictionaryGridName, JSON.stringify(cached));
        }
      },
      [dictionaryGridName, columns[dictionaryGridName]]
    );

    React.useEffect(
      () => {
        if (columns[dictionaryGridName]) {
          setTimeout(() => {
            const cachedString = localStorage.getItem(dictionaryGridName);
            if (cachedString !== null) {
              const cached = JSON.parse(cachedString);
              cached.columns = columns[dictionaryGridName];
              // localStorage.removeItem(dictionaryGridName);
              localStorage.setItem(dictionaryGridName, JSON.stringify(cached));
            }
          }, 500);
        }
      },
      [dictionaryGridName, columns[dictionaryGridName]]
    );

    return {
      name: dictionaryGridName,
      url: `/metropolis/api/${get(group, 'url', '')}`,
      dialog: true,
      onSubmit: get(group, 'onSubmit', undefined),
      Form: withProps<any, any>({ context })(DictionaryForm),
      gridProps: {
        columns: columns[dictionaryGridName] ? columns[dictionaryGridName].filter(v => v.active) : [],
        filterRow: true,
        showCheckboxes: true,
        deleting: true,
        filtering: true,
        locale: 'cz',
        adding: true,
        pageSize: 50,
        version: 13,
        pageSizeItems: [
          { id: 10, label: '10' },
          { id: 20, label: '20' },
          { id: 50, label: '50' },
          { id: 100, label: '100' },
          { id: 200, label: '200' }
        ],
        ActionBar: () => <ColumnManager agenda={dictionaryGridName} />
      },
      dialogProps: {
        repositionOnUpdate: false,
        style: { paddingTop: '20vh' },

        contentStyle: {
          width: '50vw',
          transform: 'none'
        },
        bodyStyle: {
          padding: '20px 5px'
        }
      }
    };
  }),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);

export default DictionaryGrid;



// WEBPACK FOOTER //
// ./src/modules/dictionary/DictionaryGrid.tsx